import type { IExtractRouteParamMap, IRouteTranslation } from "../../types";
import { createBreadcrumbObject, createPaths } from "../../utils";

// Base route constant
const baseRoute = `/notifications-setting`;

// * Route configuration object for notificationsSetting-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const notificationsSettingRoutesObj = {
  edit: baseRoute,
} as const;

// ! these are breadcrumbs translation not page title
const notificationsSettingRouteTranslation: IRouteTranslation<
  typeof notificationsSettingRoutesObj
> = {
  edit: "notificationsSetting",
};

// * Extracts the route parameters for the notificationsSetting route configuration.
export type INotificationsSettingRouteParams = IExtractRouteParamMap<
  typeof notificationsSettingRoutesObj
>;

// * Path functions for the notificationsSetting routes.
export const notificationsSettingPath = createPaths<
  typeof notificationsSettingRoutesObj,
  INotificationsSettingRouteParams
>(notificationsSettingRoutesObj);

// * Breadcrumbs {translation and route} for the faculty routes
export const notificationsSettingBreadcrumbs = createBreadcrumbObject<
  typeof notificationsSettingRoutesObj
>(notificationsSettingRoutesObj, notificationsSettingRouteTranslation);
